import { UIEvent } from 'react'

/**
 * This function is used to handle infinite scrolling in a dropdown.
 * When the scroll position is at the bottom of the dropdown, it triggers a callback function to fetch more data.
 *
 * @param {UIEvent<HTMLDivElement>} event - The scroll event.
 * @param {number} page - The current page of the data.
 * @param {number} totalPages - The total number of pages in the data.
 * @param {() => void} callback - The callback function to fetch more data.
 */
export default function dropdownScrollFetch(
  event: UIEvent<HTMLDivElement>,
  page: number,
  totalPages: number,
  callback: () => void,
) {
  const target = event.target as HTMLDivElement
  if (
    Math.ceil(target.scrollTop) + Math.ceil(target.offsetHeight) >= target.scrollHeight &&
    totalPages > page
  ) {
    callback()
  }
}
